import Swiper from 'swiper/swiper-bundle';

// document.addEventListener("DOMContentLoaded", () => {
  window.addEventListener("load", function(){
  const personsSlider = new Swiper(".j-personsSlider", {
    speed: 1000,
    spaceBetween: 16,
    slidesPerView: 1.4,
    loop: true,
    centeredSlides: true,
    // pagination: {
    // 	el: ".swiper-pagination",
    // 	clickable: true,
    // },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },

      breakpoints: {
        768: {
          spaceBetween: 80,
          slidesPerView: 2.5,
      },
      // on: {
      //     init: function () {
      //         setNavButtonPosition($slider);
      //     },
      //     resize: function () {
      //         setNavButtonPosition($slider);
      //     }
      // }
    }
  });
});
